import { call, put, takeLatest } from "redux-saga/effects";
import { lopApi } from "../../../api/category/lopApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eLopActionTypeIds } from "../../action-types/category/ILopActionType";
import { actions } from "../../actions";

export function* lopSaga(): any {
    yield takeLatest(eLopActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(lopApi.getAll)
    if (res.is_success) {
        yield put(actions.lop.loadSuccess(res.data))
    } else {
        yield put(actions.lop.loadError(res.message))
    }
}